import React, { useMemo } from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { GoLogoIcon } from '../GoLogoIcon/GoLogoIcon';
import { GradientBadgeProps } from './types';
import { generateGradientStyle } from './utils';
import { gradientStatic, gradientStaticWithHover, gradientAlwaysAnimate } from './GradientBadge.ve.css';

const DEFAULT_COLORS = ['#E0EBE6', '#5CD699', '#99D65C'];

export const GradientBadge: React.FC<GradientBadgeProps> = ({
    colors,
    degrees,
    withHover = false,
    withGoIcon = false,
    alwaysAnimate = false,
}) => {
    const updatedColors = useMemo(() => (colors.length !== 3 ? DEFAULT_COLORS : colors), [colors]);

    const gradientStyle = generateGradientStyle(updatedColors, degrees);

    const animationStyle = useMemo(() => {
        if (alwaysAnimate) {
            return gradientAlwaysAnimate;
        }
        if (withHover) {
            return gradientStaticWithHover;
        }
        return gradientStatic;
    }, [alwaysAnimate, withHover]);

    return (
        <Stack height="100%" width="100%" borderRadius="lg" overflow="hidden" position="relative">
            <Container width="400%" height="100%" className={animationStyle} style={gradientStyle} />
            {withGoIcon && (
                <Stack
                    height="100%"
                    width="100%"
                    zIndex="overlayBackground"
                    alignItems="center"
                    justifyContent="center"
                >
                    <GoLogoIcon />
                </Stack>
            )}
        </Stack>
    );
};
